import axios from "axios";

const API = "https://api.alfares.cloud/api/alfares/admin";

function headers() {
  let token = null;
  try {
    token = JSON.parse(localStorage.getItem("userCredentials"))?.token;
  } catch {
    token = null;
  }
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const get = (url) => axios.get(`${API}${url}`, { headers: headers() });
const post = (url, data) => axios.post(`${API}${url}`, data, { headers: headers() });
const put = (url, data) => axios.put(`${API}${url}`, data, { headers: headers() });
const del = (url) => axios.delete(`${API}${url}`, { headers: headers() });

export const adminApi = {
  getModules: () => get("/modules").then((r) => r.data),
  // users
  getUsers: () => get("/users").then((r) => r.data.users),
  createUser: (data) => post("/users", data).then((r) => r.data),
  updateUser: (id, data) => put(`/users/${id}`, data).then((r) => r.data),
  resetPassword: (id, password) =>
    post(`/users/${id}/reset-password`, { password }).then((r) => r.data),
  deleteUser: (id) => del(`/users/${id}`).then((r) => r.data),
  // roles
  getRoles: () => get("/roles").then((r) => r.data.roles),
  createRole: (data) => post("/roles", data).then((r) => r.data),
  updateRole: (id, data) => put(`/roles/${id}`, data).then((r) => r.data),
  deleteRole: (id) => del(`/roles/${id}`).then((r) => r.data),
  getRolePermissions: (id) =>
    get(`/roles/${id}/permissions`).then((r) => r.data.permissions),
  updateRolePermissions: (id, permissions) =>
    put(`/roles/${id}/permissions`, { permissions }).then((r) => r.data),
  // my account
  changeMyPassword: (currentPassword, newPassword) =>
    post("/account/change-password", { currentPassword, newPassword }).then(
      (r) => r.data
    ),
};

export function apiErrorMessage(err, fallback = "حدث خطأ") {
  return err?.response?.data?.message || fallback;
}
